<template>
  <el-dialog v-model="showNotification" append-to-body align-center width="650" center style="padding: 0 40px;" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
    <template #header>
      <div class="dialog-title">{{ title }}</div>
    </template>

    <!-- 产品上架 -->
    <div class="card-title green-text">产品上架：</div>
    <el-row class="product-name">
      <el-col :span="5">> 主产品：</el-col>
      <el-col :span="19">
        <template v-for="(item,index) in addProductList.main">
          <span style="white-space: nowrap;">{{ item }}</span>
          <span v-if="index+1 !== addProductList.main.length">、</span>
        </template>
      </el-col>
    </el-row>

    <el-row class="product-name mt-5px">
      <el-col :span="5">> 子产品：</el-col>
      <el-col :span="19">
        <template v-for="(item,index) in addProductList.child">
          <span style="white-space: nowrap;">{{ item }}</span>
          <span v-if="index+1 !== addProductList.child.length">、</span>
        </template>
      </el-col>
    </el-row>

    <el-row class="product-name mt-5px">
      <el-col :span="5">> 主+子产品：</el-col>
      <el-col :span="19">
        <template v-for="(item,index) in addProductList.mainAndChild">
          <span style="white-space: nowrap;">{{ item }}</span>
          <span v-if="index+1 !== addProductList.mainAndChild.length">、</span>
        </template>
      </el-col>
    </el-row>

    <!-- 产品下架 -->
    <div class="card-title red-text" style="margin-top: 20px;">产品下架：</div>
    <el-row class="product-name">
      <el-col :span="5">> 主产品：</el-col>
      <el-col :span="19">
        <template v-for="(item,index) in delProductList.main">
          <span style="white-space: nowrap;">{{ item }}</span>
          <span v-if="index+1 !== delProductList.main.length">、</span>
        </template>
      </el-col>
    </el-row>

    <el-row class="product-name mt-5px">
      <el-col :span="5">> 子产品：</el-col>
      <el-col :span="19">
        <template v-for="(item,index) in delProductList.child">
          <span style="white-space: nowrap;">{{ item }}</span>
          <span v-if="index+1 !== delProductList.child.length">、</span>
        </template>
      </el-col>
    </el-row>

    <el-row class="product-name mt-5px">
      <el-col :span="5">> 主+子产品：</el-col>
      <el-col :span="19">
        <template v-for="(item,index) in delProductList.mainAndChild">
          <span style="white-space: nowrap;">{{ item }}</span>
          <span v-if="index+1 !== delProductList.mainAndChild.length">、</span>
        </template>
      </el-col>
    </el-row>
    
    <div class="card-title purple-text" style="margin:15px 0px 15px 0px;">产品价格变更：</div>

    <el-table :data="tableData" border style="width: 100%"  :header-cell-style="{background:'#02A7F0 !important',color:'#ffffff'}">
      <el-table-column prop="productName" align="center" label="产品名称" />
      <el-table-column prop="oldPrice" align="center" label="价格变更前" />
      <el-table-column prop="newPrice" align="center" label="价格变更后">
        <template #default="scope">
          <span :style="{color: priceStatus(scope.row.newPrice,scope.row.oldPrice)}">{{ scope.row.newPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="oldBasePrice" align="center" label="底价变更前" />
      <el-table-column prop="newBasePrice" align="center" label="底价变更后">
        <template #default="scope">
          <span :style="{color: priceStatus(scope.row.newBasePrice,scope.row.oldBasePrice)}">{{ scope.row.newBasePrice }}</span>
        </template>
      </el-table-column>
    </el-table>

    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" size="large" @click="closeDialogEvent"> 我已知晓 </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { queryProductChangeInfo, readChangeNotice } from '@/api/tool/gen/second_phase'

// 判断价格增长
const priceStatus = (newP:string, oldP:string) => {
  let newPrice = Number(newP.split('/')[0])
  let oldPrice = Number(oldP.split('/')[0])
  if(newPrice >= oldPrice) return '#63A103'
  if(newPrice < oldPrice) return '#D9001B'
}

// 通知弹窗标题
const title = ref<string>('产品变动通知')

// 通知弹窗显影
const showNotification = ref<boolean>(false)

// 表格行类型
interface tableColumn{
  productName: string
  oldPrice: string
  newPrice: string
  oldBasePrice: string
  newBasePrice: string
}

const addProductList = ref<any>()
const delProductList = ref<any>()
const tableData = ref<tableColumn[]>([])
const noticeId = ref<number | null>(null)

const pruductInfoCategory = (arr:any) => {
  let newObj = {
    main:'',
    child:'',
    mainAndChild:''
  }
  arr.forEach((item:any) => {
    if (item.type === 1) {
      newObj.main = item.productNames.split(',')
    } else if (item.type === 2) {
      newObj.child = item.productNames.split(',')
    } else if (item.type === 3) {
      newObj.mainAndChild = item.productNames.split(',')
    }
  })
  return newObj
}

const queryProductChangeInfoApi = async () => {
  let res = await queryProductChangeInfo()
  if (res.code === 200 && res.data) {
    if(res.data.addProductList) addProductList.value = pruductInfoCategory(res.data.addProductList)
    if(res.data.delProductList) delProductList.value = pruductInfoCategory(res.data.delProductList)
    if(res.data.updateProductList) tableData.value = res.data.updateProductList
    noticeId.value = res.data.noticeId
    showNotification.value = true
  }
}

// 《我已知晓》点击事件
const closeDialogEvent = async () => {
  let res = await readChangeNotice({noticeId:noticeId.value})
  if (res.code === 200) showNotification.value = false
  
  // const now = new Date();
  // const dayOfWeek = now.getDay(); // 0是周日，1是周一，等等
  
  // // 计算到下周一的天数
  // let daysUntilMonday = dayOfWeek === 0 ? 1 : 8 - dayOfWeek;
  
  // // 如果今天是周一且当前时间早于9点，则今天就是重置日
  // if (dayOfWeek === 1 && now.getHours() < 9) {
  //   daysUntilMonday = 0;
  // }
  
  // const nextMonday = new Date(now);
  // nextMonday.setDate(now.getDate() + daysUntilMonday);
  // nextMonday.setHours(9, 0, 0, 0);
  // window.localStorage.setItem('notification',JSON.stringify({
  //   read: true,
  //   resetTime: nextMonday.getTime()
  // }))
}

onMounted(() => {
  // const readInfo = JSON.parse(window.localStorage.getItem('notification') || '{}')
  // if(!readInfo || !readInfo.read || new Date().getTime() > readInfo.resetTime) showNotification.value = true
  queryProductChangeInfoApi()
})
</script>

<style scoped lang="scss">
.dialog-footer{
  width: 100%;
  display: flex;
  justify-content: center;;
}

.dialog-title{
  font-size: 23px;
  font-weight: bold;
  color: #333333;
}

.green-text{
  color: #63A103;
}

.red-text{
  color: #D9001B; 
}

.purple-text{
  color: #8400FF;
}

.card-title{
  font-size: 18px;
}

.product-name{
  font-size: 16px;
  line-height: 25px;
}

</style>
